import script from "./AppToaster.vue?vue&type=script&setup=true&lang=js"
export * from "./AppToaster.vue?vue&type=script&setup=true&lang=js"

import "./AppToaster.vue?vue&type=style&index=0&id=6126ab4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6126ab4a"]])

export default __exports__